import { render, staticRenderFns } from "./EachProduct.vue?vue&type=template&id=5230602a&lang=pug&"
import script from "./EachProduct.vue?vue&type=script&lang=js&"
export * from "./EachProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports